<template>
    <Tooltip :text="props.tooltip" position="left" class="items-center size-7">
        <div class="cursor-pointer size-7 text-gray-700 dark:text-gray-200 hover:rounded-full hover:bg-gray-200 dark:hover:bg-slate-700 p-1 transition-all duration-300" >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
            </svg>
        </div>
    </Tooltip>
</template>
<script setup>
import { defineProps } from 'vue';
const props = defineProps({
    tooltip: {
        type: String
    }
});
</script>